import React, { useEffect, useRef } from "react";
import PropTypes from "prop-types";
import ReactEcharts from "echarts-for-react";
import * as echarts from "echarts";
import { Box, Card, CardContent, CircularProgress, Typography } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import * as V from "styles/variables";

const useStyles = makeStyles(() => ({
  card: {
    borderRadius: 8,
    boxShadow: "0 8px 24px rgba(15, 23, 42, 0.06)",
    border: "1px solid rgba(18, 24, 38, 0.06)",
    minHeight: 420,
    height: "100%",
  },
  chartBox: {
    width: "100%",
    height: 360,
  },
  loadingWrap: {
    minHeight: 320,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
}));

const RegularSeasonSeasonShotsChart = ({ seasonChart, loading }) => {
  const classes = useStyles();
  const chartRef = useRef(null);

  useEffect(() => {
    const timer = setTimeout(() => {
      chartRef.current && chartRef.current.getEchartsInstance().resize();
    }, 100);

    return () => clearTimeout(timer);
  }, [seasonChart]);

  echarts.registerTheme("RegularSeasonTheme", {
    color: V.genericColorPallette,
  });

  const option = {
    color: V.genericColorPallette,
    tooltip: {
      trigger: "axis",
      axisPointer: {
        type: "shadow",
      },
    },
    legend: {
      top: 8,
      right: 8,
    },
    grid: {
      left: 48,
      right: 24,
      top: 56,
      bottom: 36,
      containLabel: true,
    },
    xAxis: {
      type: "category",
      data: seasonChart.labels,
      axisLabel: {
        color: "#475467",
      },
    },
    yAxis: {
      type: "value",
      axisLabel: {
        color: "#475467",
      },
      splitLine: {
        lineStyle: {
          color: "rgba(148, 163, 184, 0.18)",
        },
      },
    },
    series: seasonChart.series.map((item) => ({
      name: item.name,
      type: "bar",
      stack: "total",
      data: item.data,
      barMaxWidth: 36,
    })),
  };

  return (
    <Card className={classes.card}>
      <CardContent>
        <Typography variant="subtitle1" gutterBottom>
          シーズン別 撮影本数
        </Typography>
        {loading ? (
          <Box className={classes.loadingWrap}>
            <CircularProgress size={36} />
          </Box>
        ) : (
          <div className={classes.chartBox}>
            <ReactEcharts
              ref={chartRef}
              option={option}
              theme="RegularSeasonTheme"
              notMerge
              lazyUpdate
              style={{ width: "100%", height: "100%" }}
            />
          </div>
        )}
      </CardContent>
    </Card>
  );
};

RegularSeasonSeasonShotsChart.propTypes = {
  seasonChart: PropTypes.shape({
    labels: PropTypes.array.isRequired,
    series: PropTypes.array.isRequired,
  }).isRequired,
  loading: PropTypes.bool,
};

export default RegularSeasonSeasonShotsChart;
